const $ = require('jquery');
const { post, get } = require('./api');

/**
 * Form Ajax component.
 * Allows calls interacting through APIs instead of actual POST submits.
 *
 * Usage:
 * Call FormAjax.init() to initialize
 *
 * Methods:
 *
 * init(): attaches eventlisteners
 */

const dummyData = function() {
	const id = `id-${new Date().getTime()}`;
	const date = new Date().toString();
	return `
		<div>
			<p>Nieuwe data ${date}</p>
		</div>

		 <div id="${id}">
			 <form action="/fake-endpoint" class="js-form-ajax">
				 <a class="js-form-ajax-submit" data-form-ajax-options='{ "replaceHTML": { "returnDummyData": true, "parentSelector": "#${id}" }, "textOnFail": "Failed to load more" }'>Load More</a>
			 </form>
		</div>`;
};

const initFor = function($form) {
	const $trigger = $form.querySelector('.js-form-ajax-submit');
	let options;
	try {
		options = JSON.parse($trigger.getAttribute('data-form-ajax-options'));
	} catch (e) {
		options = {};
	}

	const placeHTML = function(o, request) {
		const { parentSelector, returnDummyData } = options.replaceHTML;
		const $parent = document.querySelector(parentSelector);

		// Add next to parent
		$parent.insertAdjacentHTML(
			'afterend',
			returnDummyData ? dummyData() : request.responseText
		);

		// Run the js-form-ajax init on this content
		const $elements = $parent.parentElement.querySelectorAll('.js-form-ajax');
		for (let i = 0; i < $elements.length; i += 1) {
			initFor($elements[i]);
		}

		// Remove old form
		$parent.remove();
	};

	// Function
	const onSubmit = () => {
		// First validate
		if (!$($form).valid()) {
			return;
		}
		// Gather all values
		const values = {};
		const $inputs = $form.querySelectorAll('input, textarea, select');
		for (let i = 0; i < $inputs.length; i += 1) {
			values[$inputs[i].getAttribute('name')] = $inputs[i].value;
		}
		// On Success
		const onSuccess = function(request) {
			// Apply options
			if (options.replaceHTML) {
				placeHTML(options, request);
			}
		};
		// On Fail
		const onFail = function(request) {
			let responseData;
			try {
				responseData = JSON.parse(request.responseText);
			} catch (e) {
				responseData = { Message: request.statusText };
			}
			const validator = $($form).validate();
			const $visibleInputs = $('input:visible, textarea:visible, select:visible', $form);
			// Set the error message on the last visible input, which would put it near the trigger
			if ($visibleInputs.length > 0) {
				const key = $visibleInputs[$visibleInputs.length - 1].getAttribute('name');
				validator.showErrors({
					[key]: responseData.Message
				});
			}
			// Apply options
			if (options.replaceHTML && options.replaceHTML.returnDummyData) {
				placeHTML(options, request);
			} else if (options.textOnFail) {
				$trigger.textContent = options.textOnFail;
			}
		};
		// Post Call
		if ($form.method == 'get') {
			get($form.action, onSuccess, onFail);
		} else {
			post($form.action, values, onSuccess, onFail);
		}
	};

	// Prevent regular form submit, trigger onSubmit
	$form.addEventListener('submit', e => {
		e.preventDefault();
		onSubmit();
	});
	// On $trigger click, trigger onSubmit
	$trigger.addEventListener('click', onSubmit);
};

const init = function() {
	const $elements = document.querySelectorAll('.js-form-ajax');
	for (let i = 0; i < $elements.length; i += 1) {
		initFor($elements[i]);
	}
};

module.exports = {
	init,
	initFor
};
